/**
 * External dependencies
 */
import { useEntityProp } from '@wordpress/core-data';
import { useCallback, useMemo } from '@wordpress/element';
function useProductEntityProp(property, config) {
    var _a;
    const isMeta = property.startsWith('meta_data.');
    const metaKey = property.replace('meta_data.', '');
    const [entityPropValue, setEntityPropValue] = useEntityProp('postType', (config === null || config === void 0 ? void 0 : config.postType) || 'product', property);
    const [metadata, setMetadata] = useEntityProp('postType', (config === null || config === void 0 ? void 0 : config.postType) || 'product', 'meta_data');
    const metadataItem = useMemo(() => metadata ? metadata.find((item) => item.key === metaKey) : null, [metadata, metaKey]);
    const setMetaValue = useCallback((newValue) => {
        if (!metadataItem) {
            setMetadata([
                ...metadata,
                {
                    key: metaKey,
                    value: newValue,
                },
            ]);
            return;
        }
        setMetadata(metadata.map((item) => {
            if (item.key === metaKey) {
                return { ...item, value: newValue };
            }
            return item;
        }));
    }, [metadata, metaKey, metadataItem]);
    if (isMeta) {
        const metaValue = (_a = metadataItem === null || metadataItem === void 0 ? void 0 : metadataItem.value) !== null && _a !== void 0 ? _a : config === null || config === void 0 ? void 0 : config.fallbackValue;
        return [metaValue, setMetaValue];
    }
    return [entityPropValue, setEntityPropValue];
}
export default useProductEntityProp;
